import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

function Dashboard() {
  const navigate = useNavigate();

  useEffect(() => {
    const project = localStorage.getItem('currentProject');
    if (project) {
      navigate('/workspace');
    } else {
      navigate('/projects');
    }
  }, [navigate]);

  return <div style={{ padding: '20px', textAlign: 'center' }}>Redirigiendo...</div>;
}

export default Dashboard;
